// 按页面划分
export default {
    // 公共页面
    common: {
        detail: 'Detail',
        confirm: 'Confirm',
        cancel: 'Cancel',
        no_data: 'No Data',
        no_data_text: 'Sorry，there is no data to show right now',
        network_error: 'Unexpected error',
        network_error_text: "Sorry, an error has occured and we're working hard to fix the problem.",
        network_contact: 'Contact us',
        network_for_support: " for support",
        refresh: 'Try again',
        comeback: 'Navigate up',
        comebackHasbutton: 'Navigate up, button',
    },
    pullCom: {
        pull: 'Pull down to refresh.',
        release: 'Release to refresh',
        refresh: 'Loading...',
    },
    index: {
        searchTip: 'Search country or region',
        exclusiveTit: 'Selected for you',
        more: 'More',
        mainlandTit: 'Mainland China packages',
        hkPackageTit: 'Hong Kong (China) packages',
        popularDestTit: 'Popular destinations',
        countryList: {
            cn: 'Mainland China',
            singapore: 'Singapore',
            hk: 'Hong Kong(China)',
            us: 'United States',
            thailand: 'Thailand',
            germany: 'Germany',
            italy: 'Italy',
            more: 'More'
        },
        regionalPackage: 'Regional data packages',
        recommendPackage: 'Popular packages',
        from: 'From',
        guide: 'Guidelines',
        sepcialArea: ' packages',
        lastUpdate: 'Last Update',
        successRefresh: 'Refresh Complete',
    },
    packages: {
        sub_title: {
            us: 'Excluding Guam, Northern Mariana Islands',
            it: 'Including Vatican City, San Marino',
            va: 'Including Italy, San Marino',
            sm: 'Including Italy, Vatican City',
            ma: 'Including Western Sahara',
            eh: 'Including Morocco',
            ch: 'Including Liechtenstein',
            li: 'Including Switzerland',
            fr: 'Including Monaco',
            mc: 'Including France',
            fi: 'Including Aland Islands',
            ax: 'Including Finland',
            gu: 'Including Northern Mariana Islands',
            mp: 'Including Guam'
        },
        unlimited_packages: 'Unlimited packages',
        normal_packages: 'Normal packages',
        multi_region_packages: 'Multi-region packages',
        sale_text: 'SALE',
        high_speed_text: 'high speed data',
        high_speed_text_year: 'high speed/mo',
        periodUnit: {
            day: 'day',
            month: 'month',
            hour: 'hour',
            year: 'year',
        },
        periodUnits: {
            day: 'days',
            month: 'months',
            hour: 'hours',
            year: 'years',
        },
        periodUnitSimp: {
            day: 'd',
            month: 'mo',
            hour: 'h',
            year: 'yr'
        },
        periodUnitsSimp: {
            day: 'd',
            month: 'mo',
            hour: 'h',
            year: 'yr'
        },
        unlimited_good_name: {
            day: 'Day Pass',
            month: 'Monthly Pass',
            year: 'Yearly Pass'
        },
        day_invalid: 'Expire on the current day',
        month_invalid: 'Expire in the current month',
        immediate_valid: 'Effective from next day',
        tomorrow_day_valid: 'Effective immediately',
        tomorrow_month_valid: 'Effective from next month',
    },
    point: {
        title: 'My points',
        point_history: 'Points History',
        my_point: 'My Points',
        will_expire_on: 'will expire on',
        total: 'Total',
        dataPlans:"Data Plans",
        Balance: 'Balance',
        coupon: 'Coupons',
        more: 'More',
        redeem_for_package: 'Redeem for packages',
        redeem_for_balance: 'Redeem for balance',
        redeem_for_coupon: 'Redeem for coupons',
        points: 'points',
        signIn:"Check In",
        getPoint:"Earn Points",
        lottery:"Points & Rewards",
        getPrizes:"Win Prizes",
        membership_point_rules: 'Membership Point Rules',
        got_it: 'Got it',
        tabs: {
            all: 'All',
            earn: 'Earn',
            redeem: 'Redeem'
        },
        upgradeApp:"Please upgrade to the latest version of APP",
    },
    member: {
        membership: 'Membership',
        hello_member: 'Hello, Member',
        update: 'Update',
        vip_member_benefits: 'VIP Member Benefits',
        packages: 'Packages',
        discounts: 'Discounts',
        points: 'Points',
        membership_policy: 'Membership Policy',
        faq: 'FAQs',
        update_to_vip_membership: 'Update to VIP Membership',
        vip_member: 'VIP Member',
        valid_till: 'Valid till',
        renew: 'Renew',
        months: 'months',
        payment: 'Confirm order',
        vip_membership: 'VIP Membership',
        enjoy_vip_member_benefits: 'Enjoy {len} VIP member benefits!',
        by_purchasing_you_agree_to: 'By purchasing you agree to',
        coupon: 'Coupon',
        available_coupon: '{num} available coupon',
        no_available_coupon: 'No available coupon',
        actual_price: 'Actual Price',
        payment_success_text: 'Corresponding packages will be sent immdiately after payment confirmed.',
        balance: 'Balance',
        online_payment: 'Online Payment',
        faq_title: 'FAQs',
        policy_title: 'Membership Policy',
        introduce_title: 'VIP member benefits',
        total: 'Total',
    },
    order: {
        periodUnit: {
            day: 'day',
            month: 'month',
            year: 'year'
        },
        periodUnits: {
            day: 'days',
            month: 'months',
            year: 'years'
        },
        balance_payment_dialog: {
            title: 'Confirm Payment?',
            content: 'Pay with your account balance',
            noSelectPackageTitle: 'No package selected',
            noSelectPackageContent: 'Please select a package first',
        },
        purcase_successful: 'Update Successful',
        vip_membership: 'VIP Membership',
        total: 'Total',
        finish_btn: 'Done',
        get_order_status: 'Getting order status...',
        order_status_tip: 'Pending',
        order_status_note_user: 'Payment in process...If payment didn\'t get transferred within 10 mins, please contact us for support.',
        order_status_btn_text: 'Done',
        ios_iap_pay_btn: 'Buy now'
    },
    faq: {
        page_title: 'FAQs',
        mydevice: 'My Devices',
        more: 'More Devices',
        more_faq: 'More Questions',
        all_device: 'All Devices',
        faq_detail: 'Details',
    },
    device: {
        page_title: 'Manual',
    },
    vpn: {
        page_title: 'FAQ of VPN',
        faq_detail: 'VPN Details',
    },
    esim:{
        page_title: "ESIM",
        faq_detail: 'ESIM Details'
    },
    deviceGuide: {
        title: 'Please select your device',
        skip: 'Skip',
    },
    give_set: {
        give_set_page_title: 'Complimentary traffic setting',
        give_set_page_set_btn: 'Save',
        title: 'Complimentary package setting for members',
        desc: 'After upgrading to member, we will send the data package to your device on a regular basis except unbound devices!',
        select_device_placeholder: 'Please select the device',
        select_device_title: 'Select the device',
        no_device_title: 'You haven’t bind device yet',
        no_device_desc: 'Please select a device type for binding',
        bind_type_by_scan: 'Scan',
        bind_type_by_type: 'Model',
        disable_device_desc: 'The complimentary traffic packet can\'t be used on the device which you bound. Please bind the corresponding device',
        bind_device: 'Bind device',
        give_set_success: 'Set Successfully',
        give_set_leave_desc: 'Your settings are not saved, are you sure to leave the current page?',
        give_guide_tip: 'Click here to edit complimentary traffic setting!',
        get_it: 'Got it',
        give_set_saved: 'Saved'
    },
    guide: {
        newUser: {
            title: 'Guidelines',
            top_bar: {
                device: 'I want to use the device network',
                sim: 'I want to use the SIM card network'
            },
            step: {
                title: 'How to use the device to access the internet?',
                bind_device: 'Link device',
                buy_package: 'Purchase data',
                use: 'Get started'
            },
            sub_bar: {
                device: 'Device',
                package: 'Data',
                use: 'Start'
            },
            content: {
                device: {
                    list: [
                        {
                            title: 'To link a device:',
                            content: [
                                {
                                    text: '1. Link during sign-in, on the [Device Page], or when buying a data plan.',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'text'
                                },
                                {
                                    text: '2. Scan the QR code with your smartphone or find it in the device\'s settings.',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'text'
                                },
                                {
                                    text: '3. If no QR code, select your device model and follow the instructions.',
                                    imgSrc: '',
                                    desc: 'Ensure you complete all steps for successful linking.',
                                    parentClass: '',
                                    class: '',
                                    type:'text'
                                },
                                {
                                    text: 'Ensure you complete all steps for successful linking.',
                                    imgSrc: '',
                                    desc: 'Ensure you complete all steps for successful linking.',
                                    parentClass: '',
                                    class: '',
                                    type:'tips'
                                }

                            ],
                        }
                    ]
                },
                package: {
                    list: [
                        {
                            title: 'To buy a domestic data plan:',
                            content: [
                                {
                                    text: '1.Go to [Mall] > [Local Service] on the platform.',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2. Select a suitable data plan.',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: '3. Click [Buy] and pay.',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },

                            ]
                        },
                        {
                            title: 'To buy an international data plan:',
                            content: [
                                {
                                    text: '1.Go to [Home Page].',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2.Click on [Search Destination and Data].',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: '3.Enter your destination country or region.',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: '4. Select a data plan based on location, duration, and network type.',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: '5. Click [Buy] and complete the payment.',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: 'Remember to link your device before purchasing a plan',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'tips'
                                }
                            ]
                        },
                    ]
                },
                use: {
                    list: [
                        {
                            title: 'To use the internet:',
                            content: [
                                {
                                    text: 'To use the internet:',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '1. For Local Service(Domestic data plan): Turn on or restart your device to activate it.',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2. For Global Service(International data plan): Turn on your device at your destination for automatic activation and internet access once connected to the network.',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '(It will take 2-3 minutes to connect to the Internet for the first time, please wait patiently)',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'tips'
                                },
                            ]
                        }
                    ],
                },
                sim: {
                list: [
                    {
                        title: 'How to access the Internet with SIM card?',
                        content: [
                            {
                                text: '1. Insert available SIM card into the device card slot according to the instructions and restart the device for normal operation (For device with screen: you need to switch to SIM card mode on the screen)',
                                imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                                desc: '',
                                parentClass: '',
                                class: '',
                            },
                            {
                                text: '2.You can also connect to device WIFI with cellphone. Click SIM function to switch to SIM Mode on your App Detail Page',
                                imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                                desc: '',
                                parentClass: '',
                                class: '',
                            }
                        ]
                    }
                ]
                }
            }
        }
    },
    esimRedmption:{
        hd_title1:'eSIM',
        hd_title2:'Redemption',
        weclome_text:'Please Input your email and redemption code to get your eSIM DATAPackage. Once the eSIM QR code received. Please load it onto your phone befor the QR code expiration time.',
        email:' Your Email',
        email_placeholder:'We will send the QRCode to your email',
        confirm_mail:'Confirm Email',
        confirm_mail_placeholder:'Type the email again to ensure it\'s correct',
        redemption_code:'Redemption Code',
        redemption_code_placeholder:'Input the redemption code',
        captcha_code:'Captcha Code',
        captcha_code_placeholder:'Input the captcha code',
        redeem:'Redeem',
        not_received:'Not received email ?',
        resend_email:'Resend Email.',
        empty_email:'Please enter your email and confirm email first.',
        email_first:'Please enter your email first.',
        email_confirm_first:'Please enter your confirm email first.',
        redemption_code_first:'Please enter your redemption code first.',
        captcha_code_first:'Please enter your captcha code first.',
        resend_Success:'The mail will be delivered within 2 hours.',
        system_busy:'System is busy, please try again later.',
        resend_failed:'Resend Failed',
        redeem_failed:'Redeem Failed',
        resend_success_title:'Resend Success',
        redeem_success:'Redemption successful',
        redeem_success_title:'Redemption successful',
        failed:'Redemption failed',
    },
    "route.Home": "PAYG",
    "route.rate":"Global Rates",
    "route.record":"Payment History",
    "common.nonedata": "No Data",
    "common.nonedataRate" : "No Rate",
    "common.more" : "More",
    "route.home.flowType" : "Pay-As-You-Go",
    "route.home.rateTit" : "Rate",
    "route.home.timeUse" : "Time",
    "route.home.DataUse" : "Data",
    "route.home.MoneyUse" : "Payment",
    "route.home.history" : "Payment Histroy >",
    "route.home.OtherRate" : "All Rates",
    "route.home.useMethod" : "Methods",
    "route.home.addMinutes" : "Top-up in advance",
    "route.home.arrived" : "Turn on the device after arriving",
    "route.home.useRule" : "Terms and Conditions",
    "route.home.updateTips" : "You have not upgrade to Easy GO service",
    "route.home.updateBtn" : "Upgrade",
    "route.home.updateBtn2" : "Upgrade Now",
    "route.home.LaterUpdateBtn" : "Later",
    "route.home.updateService" : "Upgrade Service",
    "route.home.updateSuccess" : "Upgrade Successful",
    "route.home.country" : "Couontry",///Region
    "route.home.cost" : "Rate",
    "route.home.TopCost" : "Capping",
    "route.home.Success" : "Ok",
    "route.home.where" : "Unreachable location",
    "route.home.ReLogin":"Upgrade successful. The data packages in your account have been switched to data add-ons. Please relogin for the changes to take effect. And please make sure your account has sufficient funds to cover the trip.",
    "route.home.ReLoginBtn":"ReLogin",
    "route.home.flowTypeDesc":"Enable Pay-As-You-Go function to keep using our data service when there is no valid data package,an amount of your account balance will be temporally frozen to pay the data usage.(Rate:{rateCurrency} {rate}/MB)",
    "route.home.flowTypeDescLimit":"Enable Pay-As-You-Go function to keep using our data service when there is no valid data package,an amount of your account balance will be temporally frozen to pay the data usage.(Rate:{rateCurrency} {rate}/MB,Charge cap:{amountCurrency} {amount})",
    errorCode: {
        '01282001': 'Account or password error',//登录用户名或密码错误
        '01282002': 'Account is deactivated',//登录用户已停用
        '01282003': 'Account is empty',//登录用户名为空
        '01282004': 'Password is empty',//登录密码为空
        '01282501': 'Partner is not exist',//代理商不存在
        '01282503': 'Partner status is invalid'//代理商已停用
    },
    "paygo.basePayFlagMsg.true":"Open Success",
    "paygo.basePayFlagMsg.false":"OFF Success",
    "paygo.a11y.enabled":"On",
    "paygo.a11y.disabled":"Off",
    "paygo.a11y.labelAndroid":"{title}, current status is {state}",
    "paygo.a11y.labelDefault":"{title}, {state}",
    "paygo.a11y.announceState":"{title}, {state}",
    "paygo.QueryFlowHistory.NullData":"No data",
    "msgPush.tips":"Turn off {name} notifications?",
    "msgPush.closePush":"If you turn off notifications, you may miss our exclusive deals!",
    "msgPush.confirm":"Turn off",
    "msgPush.cancel":"Cancel",
    "msgPush.appPush":"Push",
    "msgPush.emailPush":"Email",
    "msgPush.loginFirst":"Not logged in or login disabled if you need to continue?",

}





// WEBPACK FOOTER //
// ./src/lang/en-us.js